export { default } from "./DisclaimerPage";
